import api from './axios';

export const getFormFields = async (activityId) => {
    const response = await api.get('/form-fields', { params: { activityId: Number(activityId) } });
    return response.data;
};


export const createOrUpdateFormFields = async (activityId, formFields) => {
    const response = await api.post(`/form-fields`, { activityId: Number(activityId), formFields });
    return response.data;
};


